/* eslint-disable import/named */
/* eslint-disable import/prefer-default-export */
import InputForm from "./input";
import SelectForm from "./select";

export const Input = InputForm;
export const Select = SelectForm;
